import { NonterminalKind } from '@nomicfoundation/slang/cst';
import { SlangNode } from './SlangNode.js';
import { EventParametersDeclaration } from './EventParametersDeclaration.js';
import { TerminalNode } from './TerminalNode.js';

import type * as ast from '@nomicfoundation/slang/ast';
import type { Doc } from 'prettier';
import type { CollectedMetadata, PrintFunction } from '../types.d.ts';

export class EventDefinition extends SlangNode {
  readonly kind = NonterminalKind.EventDefinition;

  name: TerminalNode;

  parameters: EventParametersDeclaration;

  anonymousKeyword?: string;

  constructor(ast: ast.EventDefinition, collected: CollectedMetadata) {
    super(ast, collected);

    this.name = new TerminalNode(ast.name, collected);
    this.parameters = new EventParametersDeclaration(ast.parameters, collected);
    this.anonymousKeyword = ast.anonymousKeyword?.unparse();

    this.updateMetadata(this.parameters);
  }

  print(print: PrintFunction): Doc {
    return [
      'event ',
      print('name'),
      print('parameters'),
      this.anonymousKeyword ? ' anonymous;' : ';'
    ];
  }
}
